import React, { memo } from 'react'
import style from './contentSignedIn.module.scss'
import { GAME_COMPLETE_RESULT_GENESIS } from '../../../../../../api-client/protocol-adapters/BoardGameProtocolAdapter'

import { ReactComponent as TimeLimitWinIcon } from './images/time_limit_win.svg'
import { ReactComponent as TimeLimitLoseIcon } from './images/time_limit_lose.svg'
import { ReactComponent as CapturedWinIcon } from './images/all_captured_win.svg'
import { ReactComponent as CapturedLoseIcon } from './images/all_captured_lose.svg'
import { ReactComponent as NoMoveWinIcon } from './images/no_move_win.svg'
import { ReactComponent as NoMoveLoseIcon } from './images/no_move_lose.svg'
import { ReactComponent as NoConnectionWinIcon } from './images/no_connection_win.svg'
import { ReactComponent as NoConnectionLoseIcon } from './images/no_connection_lose.svg'
import { ReactComponent as DrawIcon } from "../../../../../images/icons/ico-draw-gray.svg"
import { ReactComponent as Surrender } from "../../../../../images/icons/ico-surrender.svg"
import classNames from 'classnames';
import ContentArena from "../contentArena/ContentArena";

const ContentSignedIn = memo(({ type, win, isAllPiecesCaptured, player, gameIcon, tournament }) => {
  let content = null
  let icon = null

  const gameIconClass = classNames(style.flagIcon, {
    [style.american]: gameIcon==='american',
    [style.brazilian]: gameIcon==='brazilian',
    [style.international]: gameIcon==='international'
  });

  const eloDifferenceClass = classNames('difference-elo', {
    [style.positiveDifference]: player.differenceElo > 0,
    [style.negativeDifference]: player.differenceElo < 0,
    [style.noneDifference]: player.differenceElo === 0
  });

  switch (type) {
    case GAME_COMPLETE_RESULT_GENESIS.LOSS_ON_TIME:
      icon = win ? <TimeLimitWinIcon /> : <TimeLimitLoseIcon />
      content = win ? 'Opponent exceeded the time limit' : 'You have exceeded the time limit'
      break

    case GAME_COMPLETE_RESULT_GENESIS.NO_PAWNS_OR_MOVES:
      if (isAllPiecesCaptured) {
        icon = win ? <CapturedWinIcon /> : <CapturedLoseIcon />
        content = win
          ? "You captured all opponent's pieces"
          : 'Opponent captured all your pieces'
      } else {
        icon = win ? <NoMoveWinIcon /> : <NoMoveLoseIcon />
        content = win
          ? 'Opponent does not have a move'
          : 'You do not have a move'
      }
      break

    case GAME_COMPLETE_RESULT_GENESIS.OPPONENT_CONNECTIVITY_ERRORS:
      icon = win ? <NoConnectionWinIcon /> : <NoConnectionLoseIcon />
      content = win
        ? 'Opponent lost internet connection'
        : 'You have lost internet connection'
      break

    case GAME_COMPLETE_RESULT_GENESIS.DRAW_BY_AGREEMENT:
      icon = <DrawIcon />;
      content = 'Game ended with a draw'
      break

    case GAME_COMPLETE_RESULT_GENESIS.SURRENDER:
      icon = <div className={style.iconSurrender}><Surrender /></div>;
      content = win
        ? 'The opponent has surrendered'
        : "Don't give up! Try again!"
      break

    case GAME_COMPLETE_RESULT_GENESIS.ABANDONED:
      content =  'Your opponent has left the game. There is no change to your ELO rating.';
      break

    default:
      break
  }

  if (!content) return null

  return (
    <>
      <div className={style.inner}>
        <div className={style.wrapper}>
          {icon && <div className={`game-icon ${style.icon}`}>{icon}</div>}
          <div className={style.text}>{content}</div>
        </div>

        {player.summaryElo
          ? (
            <div className={style.eloValue}>
              <div>ELO</div>
              <div className={gameIconClass}>{player.summaryElo}</div>

              <div className={eloDifferenceClass}>
                {player.differenceElo > 0 ? '+' : ''}
                {player.differenceElo}
              </div>

            </div>
          )
          : <div className={style.eloLoading}>loading...</div>
        }
      </div>

      {Object.keys(tournament).length !== 0 && (
        <ContentArena
          ranking={tournament.rank}
          points={tournament.score}
          pointsDifference={-2}
        />
      )}
    </>
  )
})

export default ContentSignedIn
